/**
 * Datos de noticias del Colegio Bertolt Brecht
 * Array de noticias que se puede ir actualizando
 */

export const NEWS_DATA = [
    {
        id: 3,
        title: 'COMUNICADO OFICIAL',
        slug: 'comunicado-oficial',
        date: '2026-07-11',
        category: 'Comunicado',
        excerpt: 'Comunicado oficial de la Institución Educativa Privada Bertolt Brecht.',
        content: `Comunicado oficial de la Institución Educativa Privada Bertolt Brecht.`,
        image: '/assets/images/comunicado-oficial-11-07.jpeg',
        imageAlt: 'Comunicado Oficial',
        author: 'Dirección General',
        featured: true,
        imageOnly: true,
        enlace: '/comunicado-oficial',
    },
    {
        id: 2,
        title: 'INSCRIPCIONES ABIERTAS PARA LA I OLIMPIADA NACIONAL DE MATEMÁTICAS',
        slug: 'inscripciones-abiertas-olimpiada-nacional-matematicas',
        date: '2026-06-11',
        category: 'Comunicado',
        excerpt: 'La Institución Educativa Privada Bertolt Brecht invita a estudiantes de los niveles Inicial, Primaria y Secundaria a participar en la I Olimpiada Nacional de Matemáticas.',
        content: `📢 La Institución Educativa Privada "Bertolt Brecht" anuncia el inicio oficial de las inscripciones para la I Olimpiada Nacional de Matemáticas 2026.
        
        👨‍🎓👩‍🎓 La convocatoria está dirigida a estudiantes de los niveles Inicial, Primaria y Secundaria de instituciones educativas públicas y privadas del país.
        
        🧠 Esta competencia busca promover el talento matemático, el razonamiento lógico y el espíritu académico entre los participantes.
        
        📅 Las inscripciones estarán habilitadas hasta el 10 de julio de 2026.
        
        🏅 Los participantes tendrán la oportunidad de obtener diversos reconocimientos, entre ellos medallas, tablets, trofeos, gallardetes, diplomas y premios especiales.
        
        💳 Los pagos pueden realizarse mediante transferencia bancaria, depósito, Yape o Plin. Una vez efectuado el pago, se deberá enviar el comprobante correspondiente para validar la inscripción.
        
        📍 El evento se desarrollará en las instalaciones de la Institución Educativa Privada "Bertolt Brecht", ubicada en Jr. Callao N.° 257, Ayacucho.
        
        📞 Para mayor información, consulta las bases del concurso o comunícate con la comisión organizadora.
        
        ¡Esperamos contar con tu participación! 🚀`,
        image: '/assets/images/BERTOLT-MATH-2026.jpeg',
        imageAlt: 'Olimpiada Nacional de Matemáticas',
        author: 'Comisión Organizadora',
        featured: true,
        imageOnly: false,
        enlace: '/concursos',
    },
    {
        id: 1,
        title: 'Clases en Línea: Accede a tu Sala Virtual',
        slug: 'clases-en-linea-salas-virtuales',
        date: '2026-03-22',
        category: 'Comunicado',
        excerpt: 'Ya están disponibles las salas virtuales de Google Meet para todos los grados de Primaria y Secundaria. Ingresa fácilmente desde nuestra sección de Salas.',
        content: `Estimada comunidad educativa:

Nos complace informarles que las salas virtuales de Google Meet para las clases en línea están disponibles para todos los grados y secciones del colegio.

Primaria (1° al 6°) y Secundaria (1° al 5°) cuentan con su sala virtual asignada, a la que pueden acceder en todo momento desde la sección "Salas" del portal.

Acceder es muy sencillo:
- Ingresa al menú principal y selecciona "Salas"
- Elige tu nivel (Primaria o Secundaria)
- Haz clic en el botón de tu grado para unirte a la reunión

Recomendamos acceder con anticipación y tener activada la cámara y el micrófono antes del inicio de la clase.

Para consultas o soporte técnico, comunícate con el área de sistemas.

Atentamente,
La Dirección`,
        image: '/assets/images/clases-linea.jpg',
        imageAlt: 'Clases en Línea',
        author: 'Dirección General',
        featured: true,
        imageOnly: false,
        enlace: '/salas',
    },
];

/**
 * Obtener noticias destacadas
 */
export const getFeaturedNews = () => {
    return NEWS_DATA.filter(news => news.featured);
};

/**
 * Obtener últimas noticias
 * @param {number} limit - Número de noticias a obtener
 */
export const getLatestNews = (limit = 3) => {
    return NEWS_DATA.slice(0, limit);
};

/**
 * Obtener noticia por slug
 * @param {string} slug - Slug de la noticia
 */
export const getNewsBySlug = (slug) => {
    return NEWS_DATA.find(news => news.slug === slug);
};

/**
 * Obtener noticias por categoría
 * @param {string} category - Categoría de la noticia
 */
export const getNewsByCategory = (category) => {
    return NEWS_DATA.filter(news => news.category === category);
};

/**
 * Formatear fecha
 * @param {string} dateString - Fecha en formato YYYY-MM-DD
 */
export const formatNewsDate = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split('T')[0].replace(/-/g, '/');
};
